import React, { useMemo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {
    Card, CardContent, Typography, TextField, Select, MenuItem, Grid, Snackbar, Alert, DialogContentText,
    Autocomplete, CircularProgress, Button,
} from '@mui/material';
import Box from '@mui/material/Box';
import MaterialReactTable from 'material-react-table';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";

import { getLiveViewerData } from 'apis/CustomersApis';


const checkedIcon = <CheckBoxIcon fontSize="small" />;
const { primary, secondary, text, tableRow, transparent, white, black } = colors;
const { size } = typography;
const { borderRadius } = borders;
const ITEM_HEIGHT = 48;


const LiveProbesViewers = () => {


    const columns = useMemo(() =>

        [
            {
                accessorKey: 'customer_id',
                header: 'Customer ID',
                size: 150,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={customerIdOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 150 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Customer ID" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'customerIdFilterFn',

            },
            {
                header: 'Customer Name',
                accessorKey: 'org_name',
                filter: 'equals',
                id: 'org_name',
                size: 150,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={orgNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 165 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Customer Name" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'customerNameFilterFn',

            },
            {
                accessorKey: 'num_probes',
                header: 'Licensed Probes',
                id: 'num_probes',
                size: 140,
                enableColumnFilter: false,
                // Filter: ({ header }) => (
                //     <TextField
                //         size="small"
                //         variant="outlined"
                //         placeholder="Licensed Probes"
                //         type="number"
                //         onChange={(e) => header.column.setFilterValue(e.target.value)}
                //         style={{ width: 130 }}
                //     />
                // ),
                // filterFn: 'equals',
                // Footer: () => (
                //     <TextField
                //         size="small"
                //         variant="outlined"
                //         value={totals.totalLicensedProbes}
                //         InputProps={{
                //             readOnly: true,
                //             style: { textAlign: 'center', fontWeight: 'bold' }
                //         }}
                //         sx={{
                //             width: '100%',
                //             '& .MuiOutlinedInput-input': {
                //                 textAlign: 'center',
                //                 backgroundColor: '#f5f5f5',
                //                 fontWeight: 'bold'
                //             }
                //         }}
                //     />
                // ),
            },
            {
                accessorKey: 'live_probes',
                header: 'Live Probes',
                id: 'live_probes',
                size: 120,
                enableColumnFilter: false,
                // Cell: ({ cell }) => (
                //     <Box sx={{ color: cell.getValue() > 0 ? '#52c41a' : 'inherit' }}>
                //         {cell.getValue()}
                //     </Box>
                // ),
            },
            {
                accessorKey: 'num_views',
                header: 'Licensed No. of Views',
                id: 'num_views',
                size: 140,
                enableColumnFilter: false,
                filterFn: 'equals',
            },
            {
                accessorKey: 'live_viewers',
                header: 'Live Viewers',
                id: 'live_viewers',
                size: 120,
                enableColumnFilter: false,
            },
        ], []
    );

    const MyStateRole = useSelector(state => state.role);
    const UserId = useSelector(state => state.userid);
    const RoleId = useSelector(state => state.roleId);
    const Token = useSelector(state => state.accessToken);
    const isAccounting = (MyStateRole === "accounting") ? true : false;

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totals, setTotals] = useState({
        totalLicensedProbes: 0,
        totalLiveProbes: 0,
        totalLicensedViewers: 0,
        totalLiveViewers: 0
    });
    const [orgNameOptions, setOrgNameOptions] = useState([]);
    const [customerIdOptions, setCustomerIdOptions] = useState([]);


    const getViewerData = async () => {
        setLoading(true);
        try {
            // console.log("Fetching live viewer data...");
            const response = await getLiveViewerData();
            // console.log("Data array:", response);
            const dataArray = response || response.payload || response.data.payload || [];
            // console.log("Data array:", dataArray);
            setData(dataArray);
            // console.log("Data array:~bj", data);
            const calculatedTotals = response.reduce((acc, customer) => ({
                totalLicensedProbes: acc.totalLicensedProbes + (customer.num_probes || 0),
                totalLiveProbes: acc.totalLiveProbes + (customer.live_probes || 0),
                totalLicensedViewers: acc.totalLicensedViewers + (customer.num_views || 0),
                totalLiveViewers: acc.totalLiveViewers + (customer.live_viewers || 0)
            }), {
                totalLicensedProbes: 0,
                totalLiveProbes: 0,
                totalLicensedViewers: 0,
                totalLiveViewers: 0
            });
            // console.log("Calculated totals:~bj", calculatedTotals);

            setTotals(calculatedTotals);
            // console.log("Total Viewer:", totals);

            return response;
        } catch (error) {
            let errMessage = '';
            setLoading(false);
            if (error.response) {
                errMessage = error.response.data.message;

                if (error.response.status === 401 || error.response.status === 403) {
                    // Handle token expiry
                    let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                    dispatch(logout(jsonPostMsg));
                    history.push('/login');
                }
            } else if (error.request) {
                errMessage = `${error}`;
                console.log("No response received:", error.request);
            } else {
                console.log("Error:", error.message);
                errMessage = error.message;
            }

            throw errMessage; // keep behavior similar to reject()
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getViewerData();
    }, []);

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) {
            prepareCustomerData(data);
        }
    }, [data]);


    const prepareCustomerData = (data) => {

        let updtdOrgNameOptions = orgNameOptions;
        let updtdCustIdOptions = customerIdOptions;

        data.map(row => {
            const isDuplicateOrgName = updtdOrgNameOptions.includes(row.org_name);
            const isDuplicateCustId = updtdCustIdOptions.includes(row.customer_id);
            if (!isDuplicateOrgName) {
                updtdOrgNameOptions.push(row.org_name);
            }

            if (!isDuplicateCustId) {
                updtdCustIdOptions.push(String(row.customer_id));
            }


        });
        setOrgNameOptions(updtdOrgNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        setCustomerIdOptions(updtdCustIdOptions.sort(((a, b) => parseInt(a) - parseInt(b))));


    };

    return (
        <>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', height: 200, p: 3, }}>
                    <CircularProgress sx={{ color: secondary.main }} />
                </Box>
            ) : (
                <>
                    <Box sx={{ display: 'flex', gap: 3, mb: 3, mt: 3, justifyContent: 'center', width: '100%', px: 2 }}>
                        <Card sx={{ p: 2, minWidth: 150, textAlign: 'center' }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Total Licensed Probes
                            </Typography>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: text.main }}>
                                {totals.totalLicensedProbes}
                            </Typography>
                        </Card>
                        <Card sx={{ p: 2, minWidth: 150, textAlign: 'center' }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Total Live Probes
                            </Typography>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: text.main }}>
                                {totals.totalLiveProbes}
                            </Typography>
                        </Card>
                        <Card sx={{ p: 2, minWidth: 150, textAlign: 'center' }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Total Licensed No. of Views
                            </Typography>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: text.main }}>
                                {totals.totalLicensedViewers}
                            </Typography>
                        </Card>
                        <Card sx={{ p: 2, minWidth: 150, textAlign: 'center' }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Total Live Viewers
                            </Typography>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: text.main }}>
                                {totals.totalLiveViewers}
                            </Typography>
                        </Card>
                    </Box>
                    <Card>
                        <CardContent sx={{ mt: 0, px: 2, pt: 0, }}>
                            <MaterialReactTable
                                key={`live-monitoring-${Date.now()}`}
                                columns={columns}
                                data={data || []}
                                muiTableToolbarAlertBannerProps={{ sx: { display: 'none' } }}
                                muiTablePaperProps={{ sx: { boxShadow: 'none', backgroundColor: primary.main } }}
                                muiTableBodyRowProps={({ row }) => ({
                                    hover: true,
                                    sx: {
                                        color: text.main,
                                        align: 'center',
                                        '&:nth-of-type(odd)': {
                                            backgroundColor: tableRow.dark,
                                            border: 0,
                                        },
                                        '&:nth-of-type(even)': {
                                            background: tableRow.light,
                                        },
                                        // hide last border
                                        '&:last-child td, &:last-child th': {
                                            border: 0,
                                        },
                                        '&:hover td': {
                                            background: tableRow.hover,
                                        },
                                        // height: '10px', 
                                        '& td': {
                                            lineHeight: 2.1, 
                                        }
                                    },
                                })}
                                muiTableBodyCellProps={{ sx: { border: 'none', color: text.main, align: 'center', boxShadow: 'none', padding: '4px 8px', } }}
                                muiTableProps={{ sx: { backgroundColor: primary.main, color: text.main, boxShadow: 'none' } }}
                                muiTopToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none', minHeight: 0 } }}
                                muiBottomToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none' } }}
                                muiTableHeadRowProps={{ sx: { backgroundColor: primary.main, color: text.main, textAlign: 'center' }, }}
                                muiTableHeadCellProps={{ sx: { borderBottom: 0, verticalAlign: 'none', boxShadow: 'none', align: 'center', color: text.main } }}

                                enableColumnActions={false}
                                enableColumnOrdering={false}
                                enablePinning={false}
                                enableSelectAll={false}
                                enableStickyHeader={false}
                                enableClickToCopy={false}

                                positionPagination="bottom"
                                enableToolbarInternalActions={false}
                                initialState={{
                                    density: 'compact',
                                    showColumnFilters: true,
                                    boxShadow: 'none',
                                    pagination: { pageSize: 10, pageIndex: 0, pageCount: -1 },
                                    sorting: [
                                        {
                                            id: 'customer_id',
                                            desc: false,
                                        }
                                    ],
                                }}
                                positionActionsColumn="last"
                                muiTablePaginationProps={{
                                    rowsPerPageOptions: [3, 5, 10, 15, 20],
                                    sx: { color: text.main, '& p': { marginBottom: 0 }, '& .MuiSvgIcon-root': { color: text.main, }, }
                                }}
                                muiTableContainerProps={{
                                    sx: {
                                        padding: '0 !important',
                                    }
                                }}

                                renderTopToolbar={({ table }) => (
                                    <Box sx={{ display: 'flex', gap: 2, p: 2, pl: 0, justifyContent: 'start' }}>
                                        <Button
                                            onClick={getViewerData}
                                            variant="contained"
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: secondary.main,
                                                },
                                            }}
                                            color="secondary"
                                            size="small"
                                            startIcon={<RefreshIcon />}
                                            disabled={loading}
                                        >
                                            {loading ? 'Refreshing...' : 'Refresh Data'}
                                        </Button>
                                    </Box>
                                )}

                                renderRowActions={({ row }) => (
                                    <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '0.5rem' }}>


                                    </div>
                                )}

                                filterFns={{
                                    customerIdFilterFn: (row, _columnIds, filterValue) => {
                                        if (filterValue !== null) {
                                            if (filterValue !== 'All') {
                                                return String(row.getValue('customer_id')) === filterValue;
                                            } else {
                                                return true;
                                            }
                                        } else {
                                            return true;
                                        }
                                    },
                                    customerNameFilterFn: (row, _columnIds, filterValue) => {
                                        if (filterValue !== null) {
                                            if (filterValue !== 'All') {
                                                return row.getValue('org_name') === filterValue;
                                            } else {
                                                return true;
                                            }
                                        } else {
                                            return true;
                                        }
                                    },
                                }}
                            />
                        </CardContent>
                    </Card>
                </>
            )
            }

        </>
    )
}

export default LiveProbesViewers
